import { createRouter } from 'stencil-router-v2';
export { Components, JSX } from './components';

export const Router = createRouter();

export const translations = {
  'clothes': 'Bekleidung',
  'accessories': 'Zubehör',
  'stickers': 'Sticker',
  'front': "Vorderseite",
  'back': "Rückseite",
  'left': "Linke Seite",
  'right': "Rechte Seite",
  'additional': "Zusätzlich",
  'color': "Farbe",
  'capacity': "Kapazität",
  'size': "Größe",
  'form': "Form",
}

export interface Product {
  id: string;
  name: string;
  description: string;
  group: string;
  price: number;
  images: string[];
  attributes: any;
  selectSize: boolean;
  maxQuantity: number;
}